import React from 'react';
import { calculateDuration, convertTimeToMinutes, concatenateDateTime } from 'utilities/calendarFunctions';
import { TimeSlotButton } from "../../comps/calendar";

interface DateTimeInfo {
	date: string;
	startTime: string;
	endTime: string;
}

interface RecordType {
	id: string | number;
	label: string;
	dateTimeInfo: DateTimeInfo;
	[key: string]: any; // Allow extra fields
}

interface GroupedRecordsByStartTimeProps {
	dataType: string;
	records: RecordType[];
	hourHeight: number;
	startingHour: string;
	endingHour: string;
	onRecordClick: (record: RecordType) => void;
}

const GroupedRecordsByStartTime: React.FC<GroupedRecordsByStartTimeProps> = (props) => {
	const {
		dataType,
		records,
		hourHeight,
		startingHour,
		endingHour,
		onRecordClick,
	} = props;

	const sortedRecords = [...records].sort((a, b) =>
		new Date(concatenateDateTime(a.dateTimeInfo.date, a.dateTimeInfo.startTime)).getTime() -
		new Date(concatenateDateTime(b.dateTimeInfo.date, b.dateTimeInfo.startTime)).getTime()
	);

	const calculateOffsetStart = () => {
		const startTime = new Date('2024-01-01T' + startingHour);
		const hours = startTime.getHours();
		const minutes = startTime.getMinutes();
		const totalMinutes = hours * 60 + minutes;
		const calculatedOffset = (totalMinutes / 60) * hourHeight;
		return calculatedOffset;
	};

	const startDayOffset = startingHour !== '' ? calculateOffsetStart() : 0;
	const slotsContainerHeight =
		((calculateDuration(new Date('2024-01-01T' + startingHour), new Date('2024-01-01T' + endingHour)) / 60) * hourHeight) +
		hourHeight;

	const groupedRecords: { [key: string]: RecordType[] } = sortedRecords.reduce((groups, record) => {
		const startDateTime = concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.startTime);

		if (!groups[startDateTime]) {
			groups[startDateTime] = [];
		}
		groups[startDateTime].push(record);
		return groups;
	}, {} as { [key: string]: RecordType[] });

	Object.keys(groupedRecords).forEach(startDateTime => {
		groupedRecords[startDateTime].sort((a, b) =>
			(new Date(concatenateDateTime(b.dateTimeInfo.date, a.dateTimeInfo.endTime)).getTime() -
				new Date(concatenateDateTime(b.dateTimeInfo.date, a.dateTimeInfo.startTime)).getTime()) -
			(new Date(concatenateDateTime(a.dateTimeInfo.date, a.dateTimeInfo.endTime)).getTime() -
				new Date(concatenateDateTime(a.dateTimeInfo.date, a.dateTimeInfo.startTime)).getTime())
		);
	});

	return (
		<div className={`day-view-slots day-view-${dataType}`} style={{ height: slotsContainerHeight }}>
			{Object.keys(groupedRecords).map(startDateTime => (
				<div className={'day-view-slot'} key={startDateTime}>
					{groupedRecords[startDateTime].map((record, index) => (
						<TimeSlotButton
							key={record.id}
							style={{
								height:
									(calculateDuration(
										concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.startTime),
										concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.endTime)
									) / 60) * hourHeight,
								transform: `translateY(${(convertTimeToMinutes(
									concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.startTime)
								) / 60) * hourHeight - startDayOffset
									}px)`
							}}
							dataType={dataType}
							startTime={concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.startTime)}
							endTime={concatenateDateTime(record.dateTimeInfo.date, record.dateTimeInfo.endTime)}
							label={record.label}
							className={'day-view-timeslot-button index-' + index}
							onClick={() => onRecordClick(record)}
						/>
					))}
				</div>
			))}
		</div>
	);
};

export default GroupedRecordsByStartTime;